<template>
  <div class="container-fluid  content_background_color_blue2 pl-5 pt-5 pb-5">
    <nav aria-label="breadcrumb" v-if="category.project_id==0">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item"><a href="/posts">Блог</a></li>

        <li class="breadcrumb-item active" aria-current="page">{{ category.title}}</li>
      </ol>
    </nav>
  <div class="row" v-if="is_load">

    <div class="col-sm-12 col-lg-10 col-12 order-2 order-md-first ">

      <nav aria-label="breadcrumb" v-if="category.project_id>0">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/">Главная</a></li>
          <li class="breadcrumb-item"><a href="/home">Проекты</a></li>
          <li class="breadcrumb-item"><a :href="'/project/'+category.project_id">{{ category.title}}</a></li>

          <li class="breadcrumb-item active" aria-current="page">База знаний</li>
        </ol>
      </nav>
<card class="">
        <!-- shape Hero -->

        <!-- 1st Hero Variation -->
        <div class="row alert" v-if="category.last_id">
          <button type="danger" class="btn side2" v-if="islogin && category.last_id" @click="callWritePost">Написать пост
          </button>
          <button type="danger" class="btn side2" v-if="islogin==false" @click="callModalLogin">
            Авторизуйтесь,чтобы написать пост
          </button>
        </div>
</card>



      <card class="col-12 col-sm-12 mt-5 ml-1 " v-if="pinned.length>0">
        <i class="ni ni-notification-70"></i>
        <div class="col-12 col-sm-12 mt-5 ml-1"
              v-for="pinn in pinned"
              :key="pinn.last_id">
          <div class="     mb-2">

            <div class="col-lg-12 col-10 ">
              <editorjsrender :blocks_json="pinn.short.blocks"></editorjsrender>
            </div>

            <div class="col-lg-12 col-10 mt-2">

              <p><i class="fa fa-calendar-times-o"></i> {{ pinn.created_at }}
                <router-link class="btn side2 " :to="{name: 'post', params: {alias:pinn.category_post.alias, id: pinn.last_id }}"
                >Посмотреть
                </router-link>
              </p>

            </div>
          </div>

        </div>
      </card>




            <card class="col-12 col-sm-12 mt-5 ml-1 "
                 v-for="post in posts"
                 :key="post.last_id">
              <div class="col-12    mb-2">

                <div class=" ">
                  <editorjsrender   :blocks_json="post.short.blocks"></editorjsrender>
                </div>

                <div class="col-lg-12 col-10 mt-2">

                  <p><i class="fa fa-calendar-times-o"></i> {{ post.created_at }}
                    <router-link class="btn side2 " :to="{name: 'post', params: {alias:post.category_post.alias, id: post.last_id }}"
                    >Посмотреть
                    </router-link>
                  </p>

                </div>
              </div>

            </card>



      <card class="col-12 col-sm-12 mt-5 ml-1 " v-if="count>current">
        <div class="row " v-if="count>current">
          <button class="btn btn-default" @click="loadCategoryPosts()">Загрузить еще</button>

        </div>
      </card>









    </div>
    <div class="col-lg-2 col-10 mt-2 mb-2   order-sm-first order-md-2"  >
      <card>
      <div class="row">

        <span class="badge-info">{{ category.title }}</span>

      </div>
      <div class="row" ><p v-html="category.description"></p></div>
        <ul class="nav navbar flex-column" v-if="category.project_id>0">
          <li class="nav-item" v-if="category.project.main_project_id==0">
            <a class="nav-link btn side2"  @click="openProject"  href="#">Открыть проект</a>
          </li>
          <li class="nav-item" v-if="category.project.main_project_id>0">
            <a class="nav-link btn side2" @click="openProject"  href="#">Открыть задачу</a>
          </li>






        </ul>
      </card>
    </div>
  </div>
  </div>



</template>

<script>
import {eventBus} from "@/main";
import Editorjsrender from "../../models/Editorjsrender.vue";
import Api from "@/models/Api";
import Vue from "vue";

export default {
  name: "Posts",
  data: function () {
    return {
      background_header: "/img/header_bg.jpg",
      user: null,
      islogin: false,
      is_load:false,
      category:{},
      current: 0,
      count: 0,
      posts: [],
      pinned:[],
      image_url: null,
    }
  },
  mounted() {
    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });

    app.loadCategoryPosts();
  },
  methods: {
    openProject( ){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: app.category.project_id, "rand": Math.random()}});
      window.open(routeData.href, '_self');
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },

    loadCategoryPosts() {
      var app = this;
      let alias = app.$route.params.alias;

      Api.loadCategoryPosts(alias,20, app.current, function (data) {
        app.count = data.count;
        app.posts = app.posts.concat(data.posts);

        app.pinned=data.pinned;
        app.current = app.current + data.posts.length;
        app.category=data.category;
        if(data.category){
          app.is_load=true;
        }
        app.background_header = app.image_url + data.category.background;
        console.log('current');
        console.log(app.current);
        console.log('count');
        console.log(app.count);

      })
    },
    callWritePost() {
      var app=this;
      var params = {

        type: "post_new",
        blog_category_default:app.category.last_id,
        blog_category_row:app.category,
        is_project:false,
        modal_title: "Добавить пост",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название вашего поста",
              "level": 2
            }
          }]
        }
      };
      if(app.category.project_id>0){
        params['is_project']=true;
        params

      }
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
  }
}
</script>

<style scoped>

</style>